import {Injectable} from "@angular/core";

import {WebGLCanvas} from "./index";

@Injectable({providedIn: 'root'})
export class WebGLService {

  private webGLCanvas: WebGLCanvas | undefined

  public getWebGLCanvas(): WebGLCanvas {
    if (!this.webGLCanvas) {
      this.webGLCanvas = new WebGLCanvas()
    }
    return this.webGLCanvas
  }

  public clear() {
    if (this.webGLCanvas) {
      this.webGLCanvas.clean()
    }
    this.webGLCanvas = undefined;
  }
}
